import { env } from 'lib/constants/env';

import { CBID, GDPR_COMPLIANT, USStateRegionCodes } from './constants';
import { formatGeoRegion } from './utils';

export const COOKIEBOT_ENABLED = !!env.NEXT_PUBLIC_COOKIEBOT_DEFAULT_CBID;

/* INFO: The Cookiebot default CBID is set via NEXT_PUBLIC_COOKIEBOT_DEFAULT_CBID.
 * The georegions below override the default per region:
 * - GDPR compliant countries (full EEA + Switzerland + UK)
 * - US states California and Connecticut */
const georegions = [
  { region: GDPR_COMPLIANT, cbid: CBID.GDPR },
  { region: [USStateRegionCodes.California], cbid: CBID.USCalifornia },
  { region: [USStateRegionCodes.Connecticut], cbid: CBID.USConnecticut },
];

export const GEOREGIONS = georegions.map(formatGeoRegion).join(', ');
